import { Observable } from 'rxjs';
import { RestFrameworkService } from '../services/rest-framework-service';

export abstract class FileData extends RestFrameworkService<any> {

    public abstract upload(_: File): Observable<any>;

}
